import { TrashIcon } from "../images";
import { useRemoveRecommendedMutation } from "../../api";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { CustomToast } from "../ui/CustomToast";
import { getErrorMessage } from "../../utils/getErrorMessage";
import { CircularProgress, IconButton } from "@mui/material";

type Props = {
  ids: string[];
  successHandler: (ids: string[]) => void;
  isDemo?: boolean;
};

export const RemoveRecommendedBtn = ({
  ids,
  successHandler,
  isDemo,
}: Props) => {
  const { campaign_id } = useParams();
  const [removeRecommended, { isLoading }] = useRemoveRecommendedMutation();

  const removeHandler = () => {
    if (!campaign_id) return;
    removeRecommended({ campaign_id, ids })
      .unwrap()
      .then(() => successHandler(ids))
      .catch((err) =>
        toast.error(
          <CustomToast
            type="error"
            text={
              getErrorMessage(err).globalError ||
              "Something went wrong. Please try again"
            }
            title="Failed to Remove"
          />,
        ),
      );
  };

  return (
    <IconButton
      disableRipple
      onClick={removeHandler}
      sx={{
        borderRadius: "6px",
        width: "36px",
        height: "36px",
        backgroundColor: "#EEEEEE",
        "&:hover": {
          backgroundColor: "#E6E6E6",
        },
        "&.Mui-disabled": {
          backgroundColor: "#F7F7F7",
        },
      }}
      disabled={isDemo}
    >
      {isLoading ? (
        <CircularProgress size={20} color={"inherit"} />
      ) : (
        <TrashIcon color={isDemo ? "#BCBCBC" : "#585858"} />
      )}
    </IconButton>
  );
};
